export default __webpack_public_path__ + "static/media/empty-state-damage-maps.63b5ac5f.svg";